module.exports = __webpack_public_path__ + "img/logo.a4a0d6ba.png";